import {Form, Formik} from 'formik';
import Header from 'modules/header/farm/main';
import UseGetProvince from 'utilities/hooks/province/useGetProvince';
import {pageOneSchema} from './utilities/validationSchema';
import {useNavigate, useParams} from 'react-router-dom';
import InfoFormComponent from 'components/forms/info';
import useGetPostDetail from 'pages/farm/productDetail/hooks/useGetPostDetail';
import DotsLoading from 'components/loadings/dotsLoading';
import {useWholesaler} from 'context/wholesaler';
import useSetInitialProvince from 'utilities/hooks/initialProvince';

const EditInfoForm = () => {
  const {guid} = useParams();
  const navigate = useNavigate();
  const {provinces} = UseGetProvince();
  const {state, city} = useSetInitialProvince(provinces);
  const {updateWholesalerForm} = useWholesaler();
  const {productDetail, isLoading} = useGetPostDetail(guid || '');

  return (
    <>
      <Header title=" ثبت آگهی" />
      <div className="px-3 mt-6 mb-8 pb-12">
        {isLoading ? (
          <DotsLoading />
        ) : (
          <Formik
            initialValues={{
              title: productDetail?.title || '',
              description: productDetail?.description || '',
              hide_phone_number: productDetail?.phone_number ? false : true,
              city: String(productDetail?.city?.id) || String(city?.value) || '',
              state:
                String(productDetail?.state?.id) || String(state?.value) || '',
            }}
            enableReinitialize={true}
            validationSchema={pageOneSchema}
            onSubmit={values => {
              updateWholesalerForm(values);
              navigate(`/wholesaler/edit/quality/${guid}`);
            }}
          >
            {({values}) => {
              return (
                <Form>
                  <InfoFormComponent
                    cities={
                      provinces?.find(x => x?.id === Number(values?.state))
                        ?.cities || []
                    }
                    values={values}
                    app="farm"
                  />
                </Form>
              );
            }}
          </Formik>
        )}
      </div>
    </>
  );
};

export default EditInfoForm;
